import type { FC, HTMLAttributes } from "react";

import { cn } from "@roko/ui/lib/utils";

import logoDark from "../../assets/enstructure-logo-dark.png";
import logoLight from "../../assets/enstructure-logo.png";

type TEnstructureLogoProps = HTMLAttributes<HTMLDivElement>;

/** Official Enstructure logo (PNG assets for light and dark themes). */
export const EnstructureLogo: FC<TEnstructureLogoProps> = ({
  className,
  ...props
}) => {
  return (
    <div className={cn("flex items-center", className)} {...props}>
      <img
        src={logoLight}
        alt="Enstructure"
        className="block h-6 w-auto max-w-[11rem] object-contain object-left dark:hidden md:h-7"
      />
      <img
        src={logoDark}
        alt=""
        aria-hidden
        className="hidden h-6 w-auto max-w-[11rem] object-contain object-left dark:block md:h-7"
      />
    </div>
  );
};
